import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEllipse = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "sign-badge-circle" }), /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 12
	})]
});
export default SvgEllipse;
